import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ grid }: ComposedTheme) => ({
  '@global': {
    '.ag-theme-glu': {
      '--ag-material-accent-color': grid.checkbox.selectedColor,
      '--ag-borders-critical': 'solid 4px',
      '--ag-border-color': grid.border.color,
      '--ag-font-family': grid.row.text.font.fontFamily,
      '--ag-font-size': grid.row.text.font.fontSize,
      '--ag-data-color': grid.row.text.color,
      '--ag-row-hover-color': grid.row.hoverColor,
      '--ag-header-cell-hover-background-color': grid.header.hoverColor,
      '--ag-header-height': '40px',
      '--ag-header-foreground-color': grid.header.text.color,
      '--ag-secondary-foreground-color': grid.header.text.color,
      '--ag-list-item-height': '48px',
      '--ag-background-color': grid.row.backgroundColor,
      '--ag-header-background-color': grid.header.backgroundColor,
      '& .ag-header-cell': {
        ...grid.header.text.font,
        textTransform: 'none',
        color: grid.header.text.color,
        paddingRight: 8,
      },
      '& .ag-header': {
        borderBottom: `solid 4px ${grid.border.color}`,
      },
    },
  },
  root: {
    position: 'relative',
  },
  headerSticky: {
    '& .ag-header': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
    '& .ag-header .ag-header-viewport': {
      overflow: 'hidden', // Ensure column headers respect margins for horizontal scrolling for position:sticky
    },
    '& .ag-root, & .ag-root-wrapper': {
      overflow: 'inherit', // position:sticky doesn't work if any parent elements have overflow set
    },
  },
});

export default createUseStyles(styles);
